export default __webpack_public_path__ + "static/media/FOG_Grand_Marshals.f5280c50.mp4";